import React, { useContext, useEffect, useState, useMemo } from "react";
import DeleteRowIcon from "../../../images/Builder/delete.svg";
import headerDeleteIcon from "../../../images/Builder/delete_bordered.svg";
import headerDeleteDarkIcon from "../../../images/Builder/delete_bordered_dark.svg";
import refreshIcon from "../../../images/Builder/refresh.svg";
import ExmptyBasket from "../../../components/EmptyBasket";
import ExpiryDropdown from "./ExpiryDropdown";
import { MoreHorizontal, Plus } from "lucide-react";
import { useTheme } from "../../../context/ThemeContext";
import WebsocketWrapperContext from "../../../context/WebsocketWrapperContext";
import BasketBottom from "./BasketBottom";
import { CustomDropdown } from "./CustomDropdown";
import { useOptionChainContext } from "../../../context/OptionChainContext";
import { useBuilderContext } from "../../StrategyCreator/context/BuilderContext";
import { useOptionChainScreenContext } from "../context/OptionChainContext";

const Basket = ({
  currentRows,
  handleAddNewRow,
  handleAddNewStrategyClick,
  charges,
  showConfirmModal,
  computedData,
}) => {
  const {
    selectedSymbol,
    rows,
    setRows,
    selectedData,
    limitOrderStates,
    setLimitOrderStates,
    handleLotxChange,
  } = useOptionChainScreenContext();
  const { allSymbols, setAllSymbols, allOptionsData, setAlloptionsData } =
    useBuilderContext();
  const { symbolData, subscribeToSymbols } = useContext(
    WebsocketWrapperContext
  );
  const { theme } = useTheme();

  useEffect(() => {
    const scrip = selectedSymbol?.scrip;

    if (
      selectedData &&
      scrip &&
      (!limitOrderStates?.[scrip] ||
        limitOrderStates[scrip].length !== selectedData.length)
    ) {
      setLimitOrderStates((prev) => {
        const updatedStates = selectedData.map((row) => row?.orderType === "L");

        return {
          ...prev,
          [scrip]: updatedStates,
        };
      });
    }
  }, [selectedData]);

  //states
  const [rotate, setRotate] = useState(false);

  //functions
  const handlePriceRefreshClick = () => {
    setRotate(true);
    let change = false;
    let updatedRows = selectedData.map((row) => {
      if (symbolData[row.code]) {
        row.price = symbolData[row.code]?.ltp;
        if (!row.price) {
          row.price = symbolData[row.code]?.prev_close;
        }
        change = true; // assuming `change` is defined outside this scope
      }
      return row;
    });
    if (change) {
      setRows((prev) => {
        return {
          ...prev,
          [selectedSymbol?.scrip]: updatedRows,
        };
      });
    }
    setTimeout(() => {
      setRotate(false);
    }, 500);
  };

  const triggerHandleAddNewRow = () => {
    handleAddNewRow();
    handleLotxChange(1, true);
  };

  const handleDeleteAllRows = () => {
    if (selectedData?.length > 0) {
      setRows((prev) => ({
        ...prev,
        [selectedSymbol?.scrip]: [],
      }));
      setLimitOrderStates((prev) => ({
        ...prev,
        [selectedSymbol?.scrip]: [],
      }));
    }
  };

  const handleDeleteRow = (index) => {
    if (!selectedData || selectedData.length === 0) return;

    const updatedRows = selectedData.filter((_, i) => i !== index);
    const updatedLimitStates = (
      limitOrderStates[selectedSymbol?.scrip] || []
    ).filter((_, i) => i !== index);
    setRows((prev) => ({
      ...prev,
      [selectedSymbol?.scrip]: updatedRows,
    }));
    setLimitOrderStates((prev) => ({
      ...prev,
      [selectedSymbol?.scrip]: updatedLimitStates,
    }));
  };

  const handleLotSizeChange = (index, value) => {
    if (!selectedData || selectedData.length === 0) return;

    const updatedRows = selectedData.map((row, i) =>
      i === index ? { ...row, lotSize: Number(value) } : row
    );

    setRows((prev) => ({
      ...prev,
      [selectedSymbol?.scrip]: updatedRows,
    }));
    handleLotxChange(1, true);
  };

  const toggleBuySell = (index) => {
    if (!selectedData || selectedData.length === 0) return;

    const updatedRows = selectedData.map((row, i) =>
      i === index ? { ...row, isBuy: !row.isBuy } : row
    );

    setRows((prev) => ({
      ...prev,
      [selectedSymbol?.scrip]: updatedRows,
    }));
  };
  const toggleCallPut = (ind) => {
    let tSymbol = selectedData[ind].trading_symbol;
    let tCode = selectedData[ind].code;
    let instrumentName = selectedData[ind].instrumentName;
    let newRow = selectedData[ind]?.allData?.find((o, i) => {
      if (o.strike == selectedData[ind].strike) {
        return o;
      }
    });
    if (newRow != undefined && newRow != null) {
      if (selectedData[ind].isCALL) {
        tSymbol = newRow.put.trading_symbol;
        tCode = newRow.put.code;
        instrumentName = newRow.put.instrument_name;
      } else {
        tSymbol = newRow.call.trading_symbol;
        tCode = newRow.call.code;
        instrumentName = newRow.call.instrument_name;
      }
    }
    const newstate = selectedData.map((obj, index) => {
      if (index == ind) {
        let f = obj.isCALL;
        const newobj = [tCode];
        subscribeToSymbols(newobj, newobj?.exchange);
        return {
          ...obj,
          isCALL: !f,
          tradingSymbol: tSymbol,
          code: tCode,
          instrumentName: instrumentName,
          price: null,
          iv: null,
        };
      }
      return obj;
    });
    setRows((prev) => ({
      ...prev,
      [selectedSymbol?.scrip]: newstate,
    }));
  };


  const handleExpiryChange = (ind, expiry) => {
    // console.log(ind, expiry);
    if (!selectedData || selectedData.length === 0) return;
    const optionsData = allOptionsData[selectedSymbol?.scrip][expiry];
    const allstr = extractStrikeValues(optionsData);
    const [tS, tC] = updateCodeSymbol(optionsData, ind);
    const newobj = [tC];
    subscribeToSymbols(newobj, optionsData.options[0].call?.exchange);
    const newste = selectedData.map((obj, index) => {
      if (index == ind) {
        return {
          ...obj,
          expiry: expiry,
          allstrks: allstr,
          tradingSymbol: tS,
          code: tC,
          allData: optionsData.options,
          price: null,
          iv: null,
        };
      }
      return obj;
    });
    setRows((prev) => ({
      ...prev,
      [selectedSymbol?.scrip]: newste,
    }));
  };

  const handleStrikeShift = async (ind, direction) => {
    let dat = selectedData[ind];
    let { strike, allstrks, allData, isCALL, tradingSymbol, code, expiry } =
      dat;
    // console.log(allstrks, strike);
    const currentIndex = allstrks.indexOf(String(strike));

    // console.log(currentIndex);
    if (direction === "prev" && currentIndex <= 0) return;
    if (direction === "next" && currentIndex >= allstrks.length - 1) return;

    let newIndex = direction === "prev" ? currentIndex - 1 : currentIndex + 1;

    const newStrike = allstrks[newIndex];
    const newRow = allData?.find((o) => o.strike === newStrike);

    let newSymbol = tradingSymbol;
    let newCode = code;

    if (newRow) {
      if (isCALL) {
        newSymbol = newRow.call?.trading_symbol || newSymbol;
        newCode = newRow.call?.code || newCode;
      } else {
        newSymbol = newRow.put?.trading_symbol || newSymbol;
        newCode = newRow.put?.code || newCode;
      }
    }

    const updatedRows = selectedData.map((row, idx) => {
      if (idx === ind) {
        subscribeToSymbols([newCode], newRow?.exchange);
        return {
          ...row,
          strike: parseInt(newStrike),
          tradingSymbol: newSymbol,
          code: newCode,
          price: null,
          iv: null,
        };
      }
      return row;
    });
    // console.log("here");
    setRows((prev) => ({
      ...prev,
      [selectedSymbol?.scrip]: updatedRows,
    }));
  };

  const handleToggleOrderType = (index) => {
    if (!selectedSymbol?.scrip || !selectedData || selectedData.length === 0)
      return;

    setLimitOrderStates((prev) => {
      const scrip = selectedSymbol.scrip;
      const currentStates =
        prev[scrip] || Array(selectedData.length).fill(false);

      const updatedStates = [...currentStates];
      updatedStates[index] = !updatedStates[index];

      return {
        ...prev,
        [scrip]: updatedStates,
      };
    });
    const updatedRows = selectedData.map((obj, ind) => {
      if (index === ind) {
        return { ...obj, orderType: obj.orderType == "L" ? "M" : "L" };
      }
      return obj;
    });
    setRows((prev) => ({
      ...prev,
      [selectedSymbol?.scrip]: updatedRows,
    }));
  };

  const handlePriceChange = (e, ind) => {
    const rawValue = e.target.value;
    if (!/^(\d+(\.\d*)?|\.\d*)?$/.test(rawValue)) {
      return;
    }
    const newPrice = rawValue.trim() === "" ? "" : rawValue;
    // // console.log("New price:", newPrice);

    const updatedRows = selectedData.map((obj, index) => {
      if (index === ind) {
        return { ...obj, price: newPrice };
      }
      return obj;
    });
    setRows((prev) => ({
      ...prev,
      [selectedSymbol?.scrip]: updatedRows,
    }));
  };

  //helpers
  const updateCodeSymbol = (optdt, ind) => {
    const selectedRow = selectedData[ind];
    let tSymbol = selectedData[ind].trading_symbol;
    let tCode = selectedData[ind].code;
    let newRow = optdt?.options?.find((o, i) => {
      if (o.strike == selectedData[ind].strike) {
        return o;
      }
    });
    if (newRow != undefined && newRow != null) {
      if (selectedData[ind].isCALL) {
        tSymbol = newRow.call.trading_symbol;
        tCode = newRow.call.code;
      } else {
        tSymbol = newRow.put.trading_symbol;
        tCode = newRow.put.code;
      }
    }
    return [tSymbol, tCode];
  };

  const extractStrikeValues = (optionData) => {
    if (!optionData || !Array.isArray(optionData.options)) {
      return [];
    }
    return optionData.options?.map((options) => options?.strike);
  };

  if (currentRows?.length === 0) {
    return <ExmptyBasket onAddClick={handleAddNewStrategyClick} />;
  }

  return (
    <div className="w-full bg-p400 my-3 rounded-md">
      <div className="w-full min-h-[220px]">
        <div className="flex items-center justify-between border-b border-n100 border-opacity-10 px-4 py-3 rounded-t-md mb-2">
          <span className="w-[26px] text-[10px] font-medium text-n500 text-center">
            B/S
          </span>
          <span className="text-[10px] font-medium text-n500 text-center">
            Expiry
          </span>
          <span className="text-[10px] font-medium text-n500 text-center">
            Strike
          </span>
          <span className="text-[10px] font-medium text-n500 text-center">
            Type
          </span>
          <span className="text-[10px] font-medium text-n500 text-center">
            Lots
          </span>
          <div className="flex items-center text-[10px] font-medium text-n500 text-center">
            <span>Price</span>
            <div
              className="ml-2 cursor-pointer"
              onClick={handlePriceRefreshClick}>
              <img
                src={refreshIcon}
                alt="refresh"
                className={rotate ? "animate-spin" : ""}
                width={10}
                height={10}
                style={{
                  filter: theme === "dark" ? "brightness(0) invert(1)" : "none",
                }}
              />
            </div>
          </div>
          <div className="cursor-pointer" onClick={handleDeleteAllRows}>
            <img
              src={theme === "dark" ? headerDeleteDarkIcon : headerDeleteIcon}
              alt="delete"
              width={20}
              height={20}
            />
          </div>
        </div>

        <div className="flex flex-col gap-1">
          {currentRows?.map((row, ind) => (
            <div
              key={ind}
              className={`flex items-center justify-between text-center px-4 py-1 ${ind % 2 !== 0 ? "bg-n000" : ""}`}>
              <div
                className={`w-[26px] h-[26px] flex items-center justify-center rounded text-white text-[10px] font-bold cursor-pointer ${row.isBuy ? "bg-p150" : "bg-red"}`}
                onClick={() => toggleBuySell(ind)}>
                {row.isBuy ? "B" : "S"}
              </div>

              <div className="relative">
                <ExpiryDropdown
                  expiry={row.expiry}
                  expiries={selectedSymbol.option_expiries}
                  onSelect={(selected) => handleExpiryChange(ind, selected)}
                />
              </div>

              <div className="flex items-center justify-between w-24 px-2 border border-n300 rounded py-[3px]">
                <span
                  className="text-p300 text-[14px] font-medium cursor-pointer"
                  onClick={() => handleStrikeShift(ind, "prev")}>
                  -
                </span>
                <span className="cursor-pointer text-p300 text-[10px] font-medium">
                  {row.strike}
                </span>
                <span
                  className="text-p300 text-[14px] font-medium cursor-pointer"
                  onClick={() => handleStrikeShift(ind, "next")}>
                  +
                </span>
              </div>

              <div
                className={`flex items-center justify-center w-[26px] h-[26px] rounded border-[1.5px] text-[10px] text-p300 font-medium cursor-pointer ${row.isCALL ? "border-p150" : "border-red"}`}
                onClick={() => toggleCallPut(ind)}>
                {row.isCALL ? "CE" : "PE"}
              </div>

              <div className="relative">
                <CustomDropdown
                  options={[...Array(15)].map((_, i) => i + 1)}
                  value={row.lotSize}
                  onChange={(val) => handleLotSizeChange(ind, val)}
                  isLots={true}
                />
              </div>

              <div className="flex items-center">
                <button
                  className="px-2 py-1 border border-n200 rounded-l text-[10px] font-medium min-w-7 text-p300"
                  onClick={() => handleToggleOrderType(ind)}>
                  {row.orderType === "L" ? "L" : "M"}
                </button>
                <input
                  type="text"
                  value={row.price || ""}
                  className={`w-16 px-1 py-1 border border-n200 rounded-r text-center bg-p400 text-[10px] font-medium text-p300 ${row.orderType !== "L" ? "opacity-50 cursor-not-allowed" : ""}`}
                  onChange={(e) => handlePriceChange(e, ind)}
                  inputMode="decimal"
                  pattern="[0-9]*[.]?[0-9]*"
                  disabled={row.orderType !== "L"}
                />
              </div>

              <div
                className="cursor-pointer"
                onClick={() => handleDeleteRow(ind)}>
                <img
                  src={
                    theme === "dark" ? headerDeleteDarkIcon : headerDeleteIcon
                  }
                  alt="delete"
                  width={20}
                  height={20}
                />
              </div>
            </div>
          ))}

          <div className="flex items-center justify-between bg-n000 text-center px-4 py-1 opacity-50">
            <div className="w-[26px] h-[26px] flex items-center justify-center rounded text-white text-[10px] font-bold bg-n300">
              B
            </div>

            <select className="px-6 py-[4px] text-[10px] border border-n300 bg-p400 text-p300 rounded font-medium">
              <option>Expiry</option>
            </select>

            <div className="flex items-center justify-between w-24 px-2 ml-1 border border-n300 rounded py-[3px]">
              <span className="text-p300 text-[14px] font-medium">-</span>
              <span className="text-p300 text-[10px] font-medium">Strike</span>
              <span className="text-p300 text-[14px] font-medium">+</span>
            </div>

            <div className="flex items-center justify-center w-[26px] h-[26px] rounded border text-[10px] font-medium text-n400 border-n200">
              CE
            </div>

            <select className="px-[6px] py-[4px] text-[10px] border border-n300 bg-p400 text-p300 rounded font-medium">
              <option>00</option>
            </select>

            <div className="flex items-center">
              <button className="px-2 py-1 border border-n200 rounded-l text-[10px] font-medium">
                M
              </button>
              <input
                type="text"
                className="w-16 px-1 py-1 border border-n200 rounded-r text-center bg-p400 text-[10px] font-medium"
                disabled
              />
            </div>

            <div
              className="cursor-pointer p-1 text-n400 border border-p300 rounded bg-p400 shadow-sm"
              onClick={triggerHandleAddNewRow}>
              <Plus className="w-4 h-4 text-p300" />
            </div>
          </div>
        </div>
      </div>

      <div className="  text-[14px] font-medium">
        <div className="flex justify-between items-center p-4 pb-2">
          <div className="flex gap-3">
            <p className="text-[12px] font-medium text-n500">Net Premium</p>
            <p className="text-[14px] font-medium text-p300">
              {computedData?.["premium"]}
            </p>
          </div>
          <div className="flex gap-3">
            <p className="text-[12px] font-medium text-n500">Charges</p>
            <p className="text-[14px] font-medium text-p300">₹{charges}</p>
          </div>
        </div>

        <BasketBottom showConfirmModal={showConfirmModal} />
      </div>
    </div>
  );
};

export default Basket;
